import axios from "axios";

const API = process.env.REACT_APP_JOB_BOARD_API_URL;

const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

/* =========================
   DASHBOARD STATS
========================= */
export const getApprovalStats = async (token) => {
  const res = await axios.get(`${API}/admin/approvals/stats`, authHeader(token));
  return res.data;
};

/* =========================
   APPROVAL QUEUE LIST
========================= */
export const getApprovals = async (params, token) => {
  const res = await axios.get(`${API}/admin/approvals`, {
    params,
    ...authHeader(token),
  });
  return res.data;
};

/* =========================
   APPROVAL DETAIL
========================= */
export const getApprovalById = async (id, token) => {
  const res = await axios.get(
    `${API}/admin/approvals/${id}`,
    authHeader(token)
  );
  return res.data;
};

/* =========================
   APPROVE / REJECT
========================= */
export const decideApproval = async (id, status, token) => {
  await axios.patch(
    `${API}/admin/approvals/${id}/decision`,
    { status },
    authHeader(token)
  );
};

/* =========================
   BULK APPROVE
========================= */
export const bulkApprove = async (ids, token) => {
  await axios.post(
    `${API}/admin/approvals/bulk-approve`,
    { ids },
    authHeader(token)
  );
};

/* =========================
   AUTO APPROVE LOW RISK
========================= */
export const autoApproveLowRisk = async (token) => {
  const res = await axios.post(
    `${API}/admin/approvals/auto-approve`,
    {},
    authHeader(token)
  );
  return res.data;
};
